import React from 'react';

import './index.scss';

//api
import {api} from '../../../functions/api';

//material-ui
import { CircularProgress, Grid, TextField, Chip, Paper } from '@material-ui/core';


//custom components
import CustomButton from '../../../components/basic/CustomButton';

//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactQuill from 'react-quill';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Icon from '@mdi/react'
import {mdiPlus, mdiClose} from '@mdi/js'

const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class TemplatesCreateEdit extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: false,
            message: "",
            openSnackbar: false,
            editorHtml: '',
            title: "",
            subject: "",
            alias: "",
            note: "",
            placeholders: [],
            value: '',
            copied: false,
            new_tag: "",
            new_label: "",
            loadingBtn: false,
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.lists_email_templates)
            && toJS(this.props.internal.user.data.permissions.lists_email_templates.update)){

            this.props.internal.setRoute( this.props.history, this.props.location.pathname)
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.HEADER.TEMPLATES)
            let idTemplate = this.props.match.params.id
            if(idTemplate) {
                this.setState({loading: true})
                this.loadTemplate(idTemplate)
            }
        }
        else{
            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.pushRoute('/not_found')
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    closeSnackBar() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({ message: "", openSnackbar: false })
        }, TIMEOUT)
    }

    loadTemplate = async(inputId) => {
        
        let idTemplate
        if(inputId) {
            idTemplate = inputId;
        }
        else if(this.props.match.params.id) {
            idTemplate = this.props.match.params.id;
        }

        let load_data = await api({
            method: 'get',
            url: `lists/email-templates/${idTemplate}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.setState({
                title: load_data.data.data.name !== null ? load_data.data.data.name : "",
                subject: load_data.data.data.subject !== null ? load_data.data.data.subject : "",
                alias: load_data.data.data.alias !== null ? load_data.data.data.alias : "",
                note: load_data.data.data.note !== null ? load_data.data.data.note : "",
                editorHtml: load_data.data.data.email_content !== null ? load_data.data.data.email_content : "",
                placeholders: load_data.data.data.placeholders
            })
        }
        this.setState({loading: false});
    }

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline'], // 'strike', 'blockquote'
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{'list': 'ordered'}, {'list': 'bullet'}], // {'indent': '-1'}, {'indent': '+1'}
            [{ "size": [ 'small', false, 'large', 'huge' ]}],
            [{"color": []}, {background: []}],
            [{"align": []}],
            ['link']
        ],
        clipboard: {
          // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        }
      }
      /*
       * Quill editor formats
       * See https://quilljs.com/docs/formats/
       */
    formats = [
        'bold', 'italic', 'underline',
        'header',
        'list', 'bullet',
        'size',
        'color',
        'background',
        'align',
        'link'
    ]

    handleChange (html) {
        this.setState({ editorHtml: html });
    }

    handleChangeTextField = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    goBack = () => {
        this.props.internal.pushRoute('/templates')
    }

    newOrEditTemplate = async() => {
        if(this.state.title !== "" && this.state.subject !== "" && this.state.editorHtml !== "") {
            this.setState({loadingBtn: true})
            let method = "post"
            let url = "lists/email-templates"
            let params = {
                name: this.state.title,
                subject: this.state.subject,
                email_content: this.state.editorHtml,
                notification_template: this.state.subject,
                note: this.state.note
            }
            if(this.props.match.params.id) {
                method = "patch";
                url += `/${this.props.match.params.id}`
            }

            let create_data = await api({
                method: method,
                url: url,
                authorization: this.props.internal.user.access_token,
                params: params
            })

            if(create_data.success === true || (create_data.success === false && create_data.status === 201)) {
                this.props.internal.setSnackbar(create_data.data.message, true)
                // this.props.internal.pushRoute(`/templates/${create_data.data.data.id}/edit`)
                this.props.internal.pushRoute(`/templates`)
            }
            else{
                let resultError = "";
                if(create_data.data.data.errors) {
                    for(let error in create_data.data.data.errors){
                        resultError += create_data.data.data.errors[error] + " "
                    }
                }
                this.props.internal.setSnackbar(resultError, true)
            }
            this.setState({loadingBtn: false})
        }
        else {
            let result = "";
            if(this.state.title === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.TITLE_REQUIRED + " ";
            }
            if(this.state.subject === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.EMAIL_SUBJECT_REQUIRED + " ";
            }
            if(this.state.editorHtml === "") {
                result += this.props.translate.i18n.GLOBAL.ALERTS.EMAIL_CONTENT_REQUIRED + " ";
            }
            this.props.internal.setSnackbar(result, true)
        }
    }

    handleClickOnVariable = (variable) => {
    }

    handleDeletePlaceholder = async(idPlaceholder) => {
        let id = toJS(this.props.match.params.id)
        let delete_data = await api({
            method: "delete",
            url: `lists/email-templates/${id}/email-template-placeholders/${idPlaceholder}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadTemplate();
        }
        else {
            let resultError = "";
            if(delete_data.data.data.errors) {
                for(let error in delete_data.data.data.errors){
                    resultError += delete_data.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar(resultError, true)
        }
    }

    onCopy = () => {
        this.setState({copied: true});
        this.props.internal.setSnackbar(this.props.translate.i18n.MODULES.TEMPLATES.VARIABLE_WAS_COPPIED_TO_CLIPBOARD, true)
    };

    createNewPlaceholder = async() => {
        let id = toJS(this.props.match.params.id)
        if(id) {
        let create_data = await api({
            method: "post",
            url: `lists/email-templates/${id}/email-template-placeholders`,
            authorization: this.props.internal.user.access_token,
            params: {
                tag: this.state.new_tag,
                label: this.state.new_label
            }
        })

        if(create_data.success === false && create_data.status === 201) {
            this.props.internal.setSnackbar(create_data.data.message, true)
            this.setState({new_tag: "", new_label: ""})
            this.loadTemplate();
        }
        else {
            let resultError = "";
            if(create_data.data.data.errors) {
                for(let error in create_data.data.data.errors){
                    resultError += create_data.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar(resultError, true)
        }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.TEMPLATE_WAS_NOT_CREATED, true)
        }
    }

    render() {
        return (
            this.state.loading
                ?
                <CircularProgress className={'circular-progress'} />
                :
                <div className={'templates-container'}>
                <div className={'flex header'}>
                    <h1 className={'title'}>{this.props.match.params.id ? this.props.translate.i18n.MODULES.TEMPLATES.EDIT_TEMPLATE_TITLE : this.props.translate.i18n.MODULES.TEMPLATES.NEW_TEMPLATE_TITLE}</h1>
                    <div className={'back-btn'} onClick={this.goBack}>
                        <Icon path={mdiClose} size={1}/>
                    </div>
                </div>
                <div className={'p-sm-10'}>
                <Paper className={'template-detail'}>
                    <Grid container >
                        <Grid item xs={12} className={'save-btn'}>
                            <CustomButton
                                progressBar={this.state.loadingBtn}
                                onClick={this.newOrEditTemplate}
                                mystyle={'btn-orange-bg height-36'}
                                title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                justText
                            >
                                {/* <Icon path={mdiContentSaveOutline} size={1}  /> */}
                            </CustomButton>
                        </Grid>
                        <Grid item sm={12} md={5} lg={4} className={'left-col'}>
                            <Grid container direction="column">
                                <Grid item>
                                    <TextField
                                        className={'template-item'}
                                        id="title"
                                        label={this.props.translate.i18n.MODULES.TEMPLATES.NAME}
                                        value={this.state.title}
                                        onChange={this.handleChangeTextField('title')}
                                        fullWidth
                                    />
                                    <TextField
                                        className={'template-item'}
                                        id="subject"
                                        label={this.props.translate.i18n.MODULES.TEMPLATES.SUBJECT}
                                        value={this.state.subject}
                                        onChange={this.handleChangeTextField('subject')}
                                        fullWidth
                                    />
                                    <TextField
                                        className={'template-item'}
                                        id="alias"
                                        label={this.props.translate.i18n.MODULES.TEMPLATES.ALIAS}
                                        value={this.state.alias}
                                        onChange={this.handleChangeTextField('alias')}
                                        fullWidth
                                        InputProps={{
                                            disableUnderline: false,
                                            disabled: true,
                                            classes:{
                                                underline: "disabledUnderline",
                                            }
                                        }}
                                    />
                                    <TextField
                                        className={'template-item'}
                                        id="note"
                                        label={this.props.translate.i18n.MODULES.TEMPLATES.NOTE}
                                        value={this.state.note}
                                        onChange={this.handleChangeTextField('note')}
                                        fullWidth
                                    />
                                    <p className={'title-variables'}>{this.props.translate.i18n.MODULES.TEMPLATES.VARIABLES}</p>
                                    {this.props.match.params.id ? this.state.placeholders.map((variable, index) => {
                                        return (
                                            <CopyToClipboard key={variable.id} onCopy={this.onCopy} text={`{${variable.tag}}`}>
                                                <Chip
                                                    className={'placeholder-chip'}
                                                    label={variable.label}
                                                    onClick={() => this.handleClickOnVariable(variable)}
                                                    onDelete={() => this.handleDeletePlaceholder(variable.id)}
                                                />
                                            </CopyToClipboard>
                                            
                                        );
                                    })
                                    :
                                    null
                                    }
                                    <div className={'flex new-var'}>
                                        <TextField
                                            className={'w-50 template-item'}
                                            id="new-var-labe;"
                                            label={this.props.translate.i18n.MODULES.TEMPLATES.LABEL}
                                            value={this.state.new_label}
                                            onChange={this.handleChangeTextField('new_label')}
                                            
                                        />
                                        <TextField
                                            className={'w-50 template-item'}
                                            id="new-var-tag"
                                            label={this.props.translate.i18n.MODULES.TEMPLATES.TAG}
                                            value={this.state.new_tag}
                                            onChange={this.handleChangeTextField('new_tag')}
                                            
                                        />
                                        <CustomButton
                                            mystyle={'btn-orange-bg border-radius-50'}
                                            onClick={this.createNewPlaceholder}
                                        >
                                            <Icon path={mdiPlus} size={1}  />
                                        </CustomButton>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sm={12} md={7} lg={8}>
                            <ReactQuill
                                className={'template-text-editor'}
                                theme="snow"
                                onChange={this.handleChange}
                                value={this.state.editorHtml}
                                modules={this.modules}
                                formats={this.formats}
                                bounds={'.app'}
                                placeholder={''}
                            />
                        </Grid>
                        <Grid container direction="row" justify="space-between" className={'footer'}>
                            <Grid item>
                                {/* <Button onClick={this.goBack} className={'gray-text'}>
                                    {this.props.translate.i18n.GLOBAL.BUTTONS.BACK}
                                </Button> */}
                            </Grid>
                            <Grid item>
                                {/* <Button onClick={this.newOrEditTemplate} className={'orange-text'}>
                                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                </Button> */}
                                {/* <CustomButton
                                    progressBar={this.state.loading}
                                    onClick={this.newOrEditTemplate}
                                    style={'btn-orange-bg'}
                                    title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                    justText
                                /> */}
                            </Grid>
                        </Grid>
                    </Grid>
                    </Paper>
                    </div>
                </div>
                
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/templates/createEdit/index.js